<template>
  <div>
    <button
      class="btn btn-lg btn-primary px-4 white"
      @click="onClickEdit"
    >
      Edit
    </button>
    <button
      class="btn btn-lg btn-primary px-4 white"
      @click="onClickDelete"
    >
      Delete
    </button>
    <BaseDialog
      ref="globalLinkEditModal"
      :custom-content-template="customContentTemplate"
      :on-close-dialog="onCloseDialog"
      :show-close-icon="true"
      width="300px"
      height="250px"
    />
    <BaseDialog
      ref="globalLinkDeletionModal"
      :content="'Are you sure you wish to delete this Global Link?'"
      :submit-button="deleteButton"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseDialog from '@/components/Dialog/BaseDialog'
import GlobalLinkForm from './GlobalLinkForm'

export default {
  components: {
    BaseDialog
  },
  data () {
    return {
      data: {},
      customContentTemplate: GlobalLinkForm,
      deleteButton: {
        label: 'Ok',
        class: 'btn-danger',
        action: this.onConfirmDeletion
      }
    }
  },
  computed: {
    ...mapGetters({
      grapesJSInstance: 'getGrapesJSInstance',
      dynamicContent: 'getDynamicContent'
    })
  },
  methods: {
    ...mapActions([
      'getGlobalLinks',
      'deleteGlobalLink'
    ]),
    onCloseDialog () {
      this.$store.commit('SET_GLOBAL_LINK_ON_EDITION', null)
    },
    onClickEdit () {
      this.$store.commit('SET_GLOBAL_LINK_ON_EDITION', this.data)
      this.$refs.globalLinkEditModal.openDialog()
    },
    onClickDelete () {
      this.$refs.globalLinkDeletionModal.openDialog()
    },
    onConfirmDeletion () {
      const { id } = this.data
      const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
      this.deleteGlobalLink({ linkId: id, userEmail }).then(response => {
        this.getGlobalLinks({ userEmail })
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
